import React from 'react';

type SvgType = {
  className: string;
  fill: string;
  height: string;
  style: React.CSSProperties;
  viewBox: string;
  width: string;
};

const RightArrowIcon = ({ className, fill, height, style, viewBox, width }: SvgType) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <path
      d="M21.4142 13.502L15.6418 7.72966L14.2276 9.14387L17.651 12.5673L3.80423 12.5673L3.80423 14.5673L17.5205 14.5673L14.2276 17.8602L15.6418 19.2744L21.4142 13.502Z"
      fill={fill} />
  </svg>
);

RightArrowIcon.defaultProps = {
  className: '',
  fill: 'currentColor',
  height: '24px',
  style: {},
  viewBox: '0 0 24 24',
  width: '24px',
};

export default RightArrowIcon;
